                                                  
import {connect} from "react-redux";
                                                  
                                    
                                               
import {customHistory} from "../helper/history";
import {resetCategory, resetPage, setCategory, setPage} from "../actions/filter";
import ProductListPage from "../components/ProductListPage";
import {getProducts} from "../actions/products";

                                   
                       
                   
  

function mapStateToProps(state                  , props                            ) {
	return {
		products: state.content.products,
		category: state.filter.filter.selectedCategory,
		currentPageIndex: state.filter.filter.page,
		totalItems: state.filter.filter.totalItems,
		totalPages: state.filter.filter.totalPages,
		itemsPerPage: state.filter.filter.itemsPerPage,
		loadingNextPage: state.filter.loadingNextPage,
	};
}

function mapDispatchToProps(dispatch          , props                            ) {
	return {
		goHome: () => customHistory.push("/"),
		setPage: (page        ) => {
			dispatch(setPage(page));
			dispatch(getProducts());
		},
		setCategoryByKey: (key        ) => {
			dispatch(resetPage());
			dispatch(setCategory(key));
		},
		resetCategory: () => dispatch(resetCategory())
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductListPage);
